var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactbg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 909,
    height: 928,
    viewBox: "0 0 909 928",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_1753_40936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.418 400.736C580.096 410.688 574.621 479.625 611.381 472.587C655.38 464.164 682.302 335.82 595.706 279.821C539.926 243.749 441.85 246.171 435.687 302.141C430.785 346.667 452.489 381.613 536.418 400.736Z",
    fill: "#A22CFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_1753_40936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.113 499.103C242.061 509.888 217.557 426.894 182.192 453.899C139.862 486.222 167.983 649.301 283.121 670.11C357.286 683.514 458.813 630.487 440.715 562.225C426.317 507.921 388.289 478.381 292.113 499.103Z",
    fill: "#EB5C48"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.34 467.062C628.932 456.336 628.932 429.64 610.34 418.913L480.91 344.544L351.479 269.699C332.887 258.972 309.766 272.321 309.766 293.773V592.679C309.766 614.132 332.887 627.48 351.479 616.754L480.91 541.908L610.34 467.062ZM467.569 518.548H517.148L516.91 435.837C516.91 396.03 501.178 369.334 462.087 369.334C443.018 369.334 427.524 377.915 417.513 390.548V372.671H367.934V518.548H417.513V445.848C417.513 425.825 429.908 409.378 445.401 409.378C460.895 409.378 467.569 418.675 467.569 435.837V518.548Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.063 392.693H225.868C233.496 392.693 239.931 397.937 239.931 404.372V404.611C239.931 411.046 233.734 416.29 225.868 416.29H145.063C137.436 416.29 131 411.046 131 404.611V404.372C131.238 397.937 137.436 392.693 145.063 392.693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.758 404.614C248.758 398.417 253.763 393.173 260.199 393.173C266.397 393.173 271.641 398.179 271.641 404.614C271.641 410.812 266.635 416.056 260.199 416.056C254.002 416.056 248.758 411.05 248.758 404.614Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.734 404.614C279.734 398.417 284.74 393.173 291.176 393.173C297.373 393.173 302.617 398.179 302.617 404.614C302.617 410.812 297.612 416.056 291.176 416.056C284.978 416.056 279.734 411.05 279.734 404.614Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.479 434.168C213.479 427.971 218.484 422.727 224.92 422.727C231.117 422.727 236.361 427.732 236.361 434.168C236.361 440.366 231.356 445.61 224.92 445.61C218.484 445.61 213.479 440.604 213.479 434.168Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.481 422.967H331.705C339.333 422.967 345.768 428.211 345.768 434.647V434.885C345.768 441.321 339.571 446.565 331.705 446.565H259.481C251.854 446.565 245.418 441.321 245.418 434.885V434.647C245.656 428.211 251.854 422.967 259.481 422.967Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.633 494.711C225.633 488.514 230.638 483.27 237.074 483.27C243.272 483.27 248.516 488.275 248.516 494.711C248.516 500.909 243.51 506.153 237.074 506.153C230.638 506.153 225.633 501.147 225.633 494.711Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.634 483.51H343.857C351.485 483.51 357.921 488.754 357.921 495.19V495.428C357.921 501.864 351.723 507.108 343.857 507.108H271.634C264.006 507.108 257.57 501.864 257.57 495.428V495.19C257.809 488.516 264.006 483.51 271.634 483.51Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M205.835 453.236H288.308C295.936 453.236 302.371 458.48 302.371 464.916V465.154C302.371 471.59 296.174 476.834 288.308 476.834H205.835C198.207 476.834 191.771 471.59 191.771 465.154V464.677C192.01 458.241 198.207 453.236 205.835 453.236Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1753_40936",
    x: 179.259,
    y: 0.0608063,
    width: 729.124,
    height: 728.806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 127.888,
    result: "effect1_foregroundBlur_1753_40936"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1753_40936",
    x: -92.2329,
    y: 192.69,
    width: 790.847,
    height: 735.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 127.888,
    result: "effect1_foregroundBlur_1753_40936"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactbg);
export default __webpack_public_path__ + "static/media/contactbg.7da3124eb7a8114701f54a8fc51af983.svg";
export { ForwardRef as ReactComponent };